import styled, { theme } from 'academy-common-lib/utils/Styling';
const FullWidthBackgroundColor = styled.div.withConfig({
  displayName: "FullWidthBackgroundColor",
  componentId: "sc-1rzy4c2-0"
})(["background-color:", ";width:100vw;margin-left:-50vw;left:50%;position:absolute;height:100%;z-index:-1;"], props => theme.colors[props.$color]);
export default FullWidthBackgroundColor;